import { obterParametrosDaURL } from "../../../../functions";
import { api } from "../../api";
import { ApiException } from "../../api-exception";

export const AutorizarLiberacoesBaixaContasAPagar = async (
  idLote: string,
  statusAutorizacao: "S" | "N"
) => {
  const { token } = obterParametrosDaURL();

  try {
    await api.put(
      `/autorizar-liberacoes-baixa-docpagar`,
      { idLote, statusAutorizacao },
      {
        headers: { token },
      }
    );
  } catch (erro) {
    throw new ApiException(
      erro,
      "Não conseguimos autorizar a liberação de contas a pagar"
    );
  }
};